export const featureDataLeakInvestigationAndRemediation = {
    mainTitle: 'Why Choose HRD for Leak Investigation & Remediation?',
    items: [
        {
            number: '01',
            heading: 'Cutting-Edge Detection Methods – Using non-invasive technology to accurately locate leaks.'
        },
        {
            number: '02',
            heading: 'Comprehensive Solutions – Addressing both immediate leaks and underlying issues for long-term protection.'
        },
        {
            number: '03',
            heading: 'Minimal Disruption – Efficient repairs to limit downtime and tenant inconvenience.'
        },
        {
            number: '04',
            heading: 'High-Performance Materials – Using weather-resistant sealants, coatings, and membranes.'
        },
        {
            number: '05',
            heading: 'Safety & Compliance – Adhering to local building codes and WorkSafeBC standards.'
        }
    ],
    title: "Stop Water Damage Before It Spreads",
    subtitle:
        'From high-rises and commercial buildings to multi-unit residential properties, HRD provides expert leak investigation and remediation to keep your building dry, secure, and structurally sound.',
    ctaText:
        'CONTACT US TODAY TO DISCUSS HOW WE CAN PROTECT AND ENHANCE YOUR PROPERTY!',
    backgroundImage: '/assets/imgs/services/10LeakInvestigationAndRemediation/featuregridSection/fondo.png'
};
